import { render, staticRenderFns } from "./LoadingBlock.vue?vue&type=template&id=66756fe8&scoped=true&"
import script from "./LoadingBlock.vue?vue&type=script&lang=js&"
export * from "./LoadingBlock.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBlock.vue?vue&type=style&index=0&id=66756fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66756fe8",
  null
  
)

export default component.exports